module.exports = __webpack_public_path__ + "img/rosepetal-dep-scanology.95152e7a.jpg";